import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const Options = ({ store }) => {
  const [options, setOptions] = useState([]);
  const { anchor } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (store && store.physical_store && store.physical_store.card_options) {
      const allOptions = store.physical_store.card_options;
      const sortedOptions = allOptions.sort((a, b) => (a.anchor === anchor ? -1 : 1));
      setOptions(sortedOptions);
    }
  }, [store, anchor]);

  return (
    <div className="content">
      <div id="topSection">
        <div className={`overlayBox ${store.mainImageFilter ? 'overlay' : ''}`}>
          <div className="wrapper"></div>
        </div>
      </div>
      <div className="mainContent">
        <div className="wrapper mainWhiteBox">
          <div className="buttonAction">
            <a
              href="#"
              onClick={() => navigate('/home')}
              className="buyCard returnToHome"
            >
              Revenir au panier
            </a>
          </div>
          <div className="contentBody mainColor pt64 optionsList">
            {options.map((option, index) => (
              <div key={index} className="optionItem">
                <span>
                  <img src={option.image} alt={option.name} />
                </span>
                <span>{option.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Options;
